import moment from "moment"
import { IStoryDateMember } from "../interfaces/story"
import { dateFormat } from "./enum/enum"


export function getStoryDate(dateData: IStoryDateMember) {
    if(dateData.year != null && dateData.month != null && dateData.day != null) {
        return moment(dateData.date).format(dateFormat.SHORT)
    }
    else if(dateData.year != null && dateData.month != null){
        return moment(dateData.date).format(dateFormat.YEAR_MONTH)   
    } 
    else {
        return moment(dateData.date).format(dateFormat.ONLY_YEAR)
    }
}